<template>
  <div>
    <b-card>
      <b-form v-on:submit.prevent="createGpsDevice">
        <legend>{{ header }}</legend>
        <b-form-row>
          <b-col md="6">
            <b-form-group
              id="vehicle"
              label="Vehicle"
              label-for="gps_device_vehicle">
              <b-form-input
                name="vehicle"
                id="gps_device_vehicle"
                :value="displayName"
                disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="company"
              label="Company"
              label-for="gps_device_company">
              <b-form-input
                name="company"
                id="gps_device_company"
                :value="companyName"
                disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col md="6">
            <b-form-group
              id="number"
              label="Number"
              label-for="gps_device_number">
              <b-form-input
                name="number"
                id="gps_device_number"
                v-validate="'required'"
                :class="{'form-input-danger': errors.has('number')}"
                type="text"
                v-model.trim="form.number">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="type"
              label="Type"
              label-for="gps_device_type">
              <b-form-input
                name="type"
                id="gps_device_type"
                v-validate="'required'"
                :class="{'form-input-danger': errors.has('type')}"
                type="number"
                v-model.trim="form.type">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-button type="submit" variant="primary">{{ submit }}</b-button>
        <b-button
          @click="onCancel()"
          v-if="isEdit"
          variant="outline-secondary"
          class="pull-right">Cancel</b-button>
      </b-form>
    </b-card>
    <b-card>
      <div slot="header">
        <div class="mt-2 row no-gutters pull-left">
          GPS Devices of <strong class="ml-1 mr-1">{{ displayName }}</strong><b-badge pill variant="dark" class="pt-1">{{ totalGpsDevice }}</b-badge>
        </div>
      </div>
      <b-list-group class="no-box" v-if="totalGpsDevice">
        <b-list-group-item v-for="gps_device in gps_devices" :key="gps_device.id">
          <div class="pull-left pt-3">
            <span>
              {{ gps_device.number }}
            </span>
            <b-badge variant="success" v-if="gpsDefault(gps_device.metadata)">Default</b-badge>
          </div>
          <div class="pull-right">
            <b-button
              variant="outline-success"
              class="m-md-2"
              v-b-modal.set_default
              @click="defaultGpsId = gps_device.id"
              v-if="!gpsDefault(gps_device.metadata)">
              Set as Default
            </b-button>
            <b-button @click="editGpsDevice(gps_device.id)" variant="outline-primary"><i class="fa fa-pencil-square-o fa-lg"></i>&nbsp; Edit</b-button>
            <b-button v-b-modal.delete_gps_device @click="deleteGpsId = gps_device.id" variant="outline-danger" class="m-md-2"><i class="fa fa-trash-o fa-lg"></i></b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card>
    <div>
      <b-modal
        id="delete_gps_device"
        title="Delete GPS Device"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="deleteGpsDevice(deleteGpsId)">
        <p class="my-4">Are you sure want to delete this GPS Device ?</p>
      </b-modal>
      <b-modal
        id="set_default"
        title="Set as Default"
        header-bg-variant="success"
        ok-variant="success"
        @ok="setDefault(defaultGpsId)">
        <p class="my-4">Are you sure do you want to set as default this GPS Device ?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { isUndefined, find } from 'lodash';

export default {
  name: 'gps_devices',
  data() {
    return {
      deleteGpsId: '',
      defaultGpsId: '',
      form: {
        number: '',
        type: '',
      },
      isEdit: false,
    };
  },
  created() {
    this.$store.dispatch('vehicles/LOAD_DETAIL_DATA').then(() => {
      const { company: { id } } = this.detailedInfo;
      this.$store.commit('gpsDevices/SET_COMPANY_ID', id);
    });
    this.$store.commit('gpsDevices/SET_VEHICLE_ID', this.vehicleId);
    this.$store.dispatch('gpsDevices/LOAD_DATA');
  },
  computed: {
    gps_devices() {
      return this.$store.getters['gpsDevices/gps_devices'];
    },
    detailedInfo() {
      return this.$store.getters['vehicles/get_detail_data'];
    },
    displayName() {
      return this.detailedInfo.reg_no;
    },
    company() {
      return this.detailedInfo.company || {};
    },
    companyId() {
      return this.company.id;
    },
    companyName() {
      return this.company.name;
    },
    vehicleId() {
      const { vehicleId } = this.$route.params;
      return vehicleId;
    },
    header() {
      return !this.isEdit ? 'Add GPS Device' : 'Edit GPS Device';
    },
    submit() {
      return !this.isEdit ? 'Submit' : 'Save Changes';
    },
    totalGpsDevice() {
      return this.gps_devices.length;
    },
  },
  watch: {
    companyId(newCompanyId) {
      this.$store.commit('gpsDevices/SET_COMPANY_ID', newCompanyId);
    },
  },
  methods: {
    createGpsDevice() {
      const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_DATA';
      this.$store.dispatch(`gpsDevices/${action}`, this.form).then(() => {
        this.$store.dispatch('gpsDevices/LOAD_DATA');
        this.clearForm();
        setTimeout(() => {
          this.errors.items.splice(0);
        }, 10);
      });
    },
    editGpsDevice(id) {
      const gpsDevice = find(this.gps_devices, { id });
      this.form = { ...gpsDevice };
      this.isEdit = true;
    },
    deleteGpsDevice(id) {
      this.$store.dispatch('gpsDevices/DELETE_DATA', id).then((deleted) => {
        if (deleted) this.$store.dispatch('gpsDevices/LOAD_DATA');
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      this.isEdit = false;
      this.clearForm();
      setTimeout(() => {
        this.errors.items.splice(0);
      }, 10);
    },
    clearForm() {
      this.form = {
        number: '',
        type: '',
      };
    },
    gpsDefault(metadata) {
      const { active } = metadata || {};
      return active;
    },
    setDefault(id) {
      const removeDefault = find(this.gps_devices, { metadata: { active: 1 } });
      this.$store.dispatch('gpsDevices/SET_DEFAULT', id).then((ok) => {
        if (ok) {
          if (isUndefined(removeDefault)) {
            this.$store.dispatch('gpsDevices/LOAD_DATA');
          } else {
            const { id: idRemove } = removeDefault;
            this.$store.dispatch('gpsDevices/REMOVE_DEFAULT', idRemove).then((removed) => {
              if (removed) this.$store.dispatch('gpsDevices/LOAD_DATA');
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="sass">
.form-input-danger
  border: 1px solid #f86c6b;
</style>




// WEBPACK FOOTER //
// src/views/pages/admin/vehicles/detail/GPSDevices.vue